import { render, staticRenderFns } from "./AddHospitalDoctors.vue?vue&type=template&id=3361cb9a&scoped=true"
import script from "./AddHospitalDoctors.vue?vue&type=script&lang=js"
export * from "./AddHospitalDoctors.vue?vue&type=script&lang=js"
import style0 from "./AddHospitalDoctors.vue?vue&type=style&index=0&id=3361cb9a&prod&lang=css"
import style1 from "./AddHospitalDoctors.vue?vue&type=style&index=1&id=3361cb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3361cb9a",
  null
  
)

export default component.exports